export const GRAPHQL_URL = `${window.ENV.HTTP_URL}/devi/graphql`
